import "../../css/src/app.scss";

import { pre } from "./utilities";

(function ($) {
    $(document).ready(function () {
    	
    	if( $("#liste_services").length){
	    	var contenu_original=  $("#detail_service .col-8").html();
	        $("#liste_services li").hover(
	        	function(){ 
	        		
	        		var current_index = $(this).index( "#services li");

	        		$("#services .services_bg").removeClass("foreground");
	        		$("#services .services_bg").eq(current_index).addClass("foreground");
	        		$("#liste_services").addClass("active");
	        		$("#detail_service .col-8").html($(this).find("div").html());

	        	},function(){

	        		//$("#liste_services").css("background-image",'url()');
	        		$("#services .services_bg").removeClass("foreground");
	        		$("#liste_services").removeClass("active");
	        		$("#detail_service .col-8").html(contenu_original);
	        	}
	        );
	    }

        if( $("#sectors").length){
	        $("#sectors .col-2").hover(
	        	function(){
	        		var current_index = $(this).index( "#sectors .wrapper .col-s-6");

	        		$("#sectors .sectors_bg").removeClass("foreground");
	        		$("#sectors .sectors_bg").eq(current_index).addClass("foreground");
	        	},function(){
	        		
	        	}
	        );
	    }

	    if( $("#seeallprojects").length){
	        $("#seeallprojects a").on("click",function(e){
	        	e.preventDefault();
	        	$("#seeallprojects").hide();
	        	$("#projects_linked .notactive").removeClass("notactive");
	        });
	    }

	    function gestion_cases_cochees(id_type_filtre, nom_de_la_case_cochee){
	    	if( nom_de_la_case_cochee=="all_service" || nom_de_la_case_cochee=="all_secteur"){
	    		$('#'+id_type_filtre+' li input').attr('checked', false);
	     		$('#'+id_type_filtre+' li input:first').prop('checked', 'checked');
	    	}else{
	    		$('#'+id_type_filtre+' li input:first').prop('checked', false);
	    	}

	    	if($('#'+id_type_filtre+' li input:checked').length==0){
	    		$('#'+id_type_filtre+' li input:first').prop('checked', 'checked');
	    	}
	    }

	    function affichage_projets(){
	    	var classFiltres = "";
	    	$('#liste_projects .col-4').hide();
	    	if($("#filtres li input:checked").length > 0){

	    		$("#filtre_secteur li input:checked").each(function(){
	    			//classFiltres = classFiltres + "."+$(this).attr("name");
	    			var secteurFiltre = "."+$(this).attr("name");

	    			$("#filtre_service li input:checked").each(function(){
	    				//classFiltres = classFiltres + "."+$(this).attr("name");
	    				classFiltres = secteurFiltre + "."+$(this).attr("name") + " ";
	    				$('#liste_projects .col-4'+classFiltres).show();
	    			});
	    			//classFiltres = classFiltres + " ";
	    		});

	    	}else{
	    		$('#liste_projects .col-4.visible').show();
	    	}

	    	if($('#liste_projects .col-4:visible').length==0){
	    		$('#liste_projects .aucunresultat').addClass("active");
	    	}else{
	    		$('#liste_projects .aucunresultat').removeClass("active");
	    	}
	    }

	    function nb_projets_actifs(){
	    	//var nb_projets_actifs = $('#liste_projects .col-4:visible').length;
	    	//$("#nombre_projets").html("("+nb_projets_actifs+")");
	    }

	    if( $("#filtres").length){
	        $("#filtres li input").on("change",function(e){
	        	var id_type_filtre = $(this).parent().parent().attr('id');
	        	var nom_de_la_case_cochee = $(this).attr("name");
	        	gestion_cases_cochees(id_type_filtre, nom_de_la_case_cochee);
	        	affichage_projets();
	        	//nb_projets_actifs();
	        });

	        var firstLoad = 1;
	        if($(window).width() >= 768){
		        $(window).on('scroll', function (event) {
		        	var y=$(window).scrollTop();
		        	var wh=$(window).height();
	                var dh=$(document).height();
	                if(y+wh > dh -350 && firstLoad ==1){
	                	$('#liste_projects .col-4').show();
	                	firstLoad = 0;
	                }
		        });
		    }else{
		    	$('#liste_projects .col-4').show();
		    }
	    }


	    if( $(".formulaire_contact").length ){
	    	$("input[name=services]").on("change",function(e){
	    		var services_choisis = "";
	    		$("input[name=services]:checked").each(function(){
	    			services_choisis += $(this).val()+"\r";
	    		});
	    		$("#hidden_services").html(services_choisis);
	    	});
		}

	    if( $(".liste_jobs").length){
		    $(".liste_jobs .jobs:not(.showing)").on("click",function(e){
		    	$(".liste_jobs .jobs").removeClass("showing");
				$(this).addClass("showing");
			});
		}

		/*

		if( $(".liste_actualites").length){
		    $('.liste_actualites .col-4').each(function(){  
		        var highestBox = 0;

		        $(this).find('.column').each(function(){
		            if($(this).height() > highestBox){  
		                highestBox = $(this).height();  
		            }
		        })

		        $(this).find('.column').height(highestBox);
		    });
		}

		*/

		if( $(".insight_photos").length){
			var $grid = $('.grid').isotope({
			  itemSelector: '.grid-item',
			  percentPosition: true,
			  masonry: {
			    columnWidth: '.grid-sizer'
			  }
			});

			$grid.imagesLoaded().progress( function() {
			  $grid.isotope('layout');
			});

			$('.grid').magnificPopup({
			  delegate: 'a',
			  type: 'image',
			  gallery:{
			    enabled:true
			  }
			});
		}

		// Page notre équipe
		if($(".col-6.galerie").length){
			$('.galerie').magnificPopup({
			  delegate: 'a',
			  type: 'image',
			  gallery:{
			    enabled:true
			  }
			});
		}

		if($("#slider_galerie").length){
			if($("#slider_galerie .swiper-slide").length<2){
				$("#slider_galerie").addClass("no_slideshow");
			}
			if($(".line_4 .first").innerHeight() < $(".line_4 .col-6").not('.first').innerHeight()){
				$(".line_4 .first").css("height", $(".line_4 .col-6").not('.first').innerHeight());
			}
		}


		function animationHomepage(index){
			var overlayer = index;
			if($("#slider .swiper-slide:eq("+index+")").hasClass("animation_1")){
				TweenMax.fromTo('#overlayer1 .st1',0.70, {ease: Power4.easeOut, xPercent:110}, {xPercent:0, delay:1} ); // blanc
				TweenMax.fromTo('#overlayer1 .st4',0.50, {ease: Power4.easeOut, y:-800}, {y:0, delay:1.40} ); // rouge
				TweenMax.fromTo('#overlayer1 .st2',0.70, {ease: Power4.easeOut, y:1000}, {y:0, delay:1.60} ); // bleu
			}else if($("#slider .swiper-slide:eq("+index+")").hasClass("animation_2")){
				TweenMax.fromTo('#overlayer2 .st4',0.70, {ease: Power4.easeOut, y:-800}, {y:0, delay:1} ); // blanc
				TweenMax.fromTo('#overlayer2 .st5',0.50, {ease: Power4.easeOut, y:-800}, {y:0, delay:1.40} ); // bleu
				TweenMax.fromTo('#overlayer2 .st6',0.70, {ease: Power4.easeOut, x:-1000}, {x:0, delay:1.80} ); // rouge
			}else if($("#slider .swiper-slide:eq("+index+")").hasClass("animation_3")){
				TweenMax.fromTo('#overlayer3 .st4',0.50, {ease: Power4.easeOut, y:-800}, {y:0, delay:1} ); // blanc
				TweenMax.fromTo('#overlayer3 .st6',0.70, {ease: Power4.easeOut, xPercent:110}, {xPercent:0, delay:1.40} ); // rouge
				TweenMax.fromTo('#overlayer3 .st5',0.70, {ease: Power4.easeOut, y:1000}, {y:0, delay:1.60} ); // bleu
			}else if($("#slider .swiper-slide:eq("+index+")").hasClass("animation_4")){
				TweenMax.fromTo('#overlayer4 .st2',0.50, {ease: Power4.easeOut, y:-800}, {y:0, delay:1} ); // blanc
				TweenMax.fromTo('#overlayer4 .st3',0.70, {ease: Power4.easeOut, xPercent:110}, {xPercent:0, delay:1.40} ); // rouge
				TweenMax.fromTo('#overlayer4 .st4',0.70, {ease: Power4.easeOut, x:-1000}, {x:0, delay:1.40} ); // bleu
			}else{
				TweenMax.staggerFromTo('#overlayer'+overlayer+' polygon, #overlayer'+overlayer+' path',1.25, {opacity:0}, {opacity:1}, 0.4);
			}
			if($(window).width() <= 768){
				TweenMax.staggerFromTo( "#slider .swiper-slide:eq("+index+") .inner_slide span", 5/3, {width:0}, {width:"33.33%", ease: Power0.easeNone, onComplete:function(){TweenMax.set(this.target, {borderRight:"solid 1px #fff"})}}, 5/3, function(){
					TweenMax.set("#slider .swiper-slide .inner_slide span", {clearProps:"borderRight", delay:0.5});
				});
			}
			
			//TweenMax.staggerFromTo('#slider .swiper-slide-active polygon, #slider .swiper-slide-active path',1.25, {opacity:0}, {opacity:1}, 0.4);
		}

		function nextSlide() {
		  if ( $("#slider .swiper-slide:eq("+(mySwiper.realIndex + 1)+")").length) {
		    mySwiper.slideNext();
		  } else {
		    mySwiper.slideToLoop(0)
		  }
		}

		function prevSlide() {
		  if ( mySwiper.realIndex - 1 >= 0) {
		    mySwiper.slidePrev();
		  } else {
		    mySwiper.slideToLoop($("#slider .swiper-slide").length -1);
		  }
		}

		
		if($("#slider").length){

			var looptrueFalse = $(window).width() <= 768;

			//var currentSlide = 0;

			function launchAnim(){
				currentSlide = $(window).width() <= 768?this.activeIndex:this.realIndex;
				animationHomepage(currentSlide);
			}

		    var mySwiper = new Swiper ('.swiper-container', {
			    // Optional parameters
			    direction: 'horizontal',
			    loop: looptrueFalse,
			    effect: 'fade',
			    //effect: 'slide',
			    //effect: 'cube',
			    autoplay: {
				    delay: 5000,
				},
				navigation: {
			      nextEl: false,
			      prevEl: false,
			    },
			    on: {
			    	init: launchAnim,
			    	slideChange: launchAnim
			    }
			});


			

		    $('.swiper-button-next').on("click",nextSlide);
		    $('.swiper-button-prev').on("click",prevSlide);

		    /*

			mySwiper.on('slideChange', function(e) {
			    currentSlide = $(window).width() <= 768?mySwiper.activeIndex:mySwiper.realIndex;
			    animationHomepage(currentSlide);
			});

			currentSlide = $(window).width() <= 768?mySwiper.activeIndex:mySwiper.realIndex;
			animationHomepage(currentSlide);
			*/

		}else{
			var currentSlide = 0;

		    var mySwiper = new Swiper ('.swiper-container', {
			    // Optional parameters
			    direction: 'horizontal',
			    loop: true,
			    effect: 'fade',
			    //effect: 'slide',
			    //effect: 'cube',
			    autoplay: {
				    delay: 5000,
				},
			    navigation: {
			      nextEl: '.swiper-button-next',
			      prevEl: '.swiper-button-prev',
			    },
			});
		}


		function animationHeadersInterne(){
			if($("#overlayer5").length){
				//TweenMax.FromTo('#overlayer5 .st0',2, {left:-100}, {left:0});
				TweenMax.fromTo('#overlayer5 .st0',0.50, {ease: Power4.easeOut, y:500}, {y:0, delay:1} ); // blanc
				TweenMax.fromTo('#overlayer5 .st1',0.50, {ease: Power4.easeOut, x:-300}, {x:0, delay:1.40} ); // rouge
				TweenMax.fromTo('#overlayer5 .st3',0.50, {ease: Power4.easeOut, y:-300}, {y:0, delay:1.60} ); // bleu
			}
		}

		animationHeadersInterne();

		$("#loupe").on("click",function(e){
			e.preventDefault();
			$("header > a").hide();
			$(".wrapper_header").addClass("active");
			$("#searchform #s").focus();
		});

		$("#close_search_form").on("click",function(e){
			e.preventDefault();
			$(".wrapper_header").removeClass("active");
			$("header > a").show();
			//$("#searchform #s").focus();
		});

		var cookie = null;
		$('.popup-youtube, .popup-vimeo, .popup-gmaps').on('click', e => {
			cookie = e.target.dataset.cookie;
		});

		$('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({ 
			callbacks: { 
				open: () => {
					if(document.querySelector(`.cookie-acceptance__modal[data-hide-on-vendor-consent="${cookie}"]`).dataset.display == 'none') {
						if(cookie != "gmaps") {
							document.querySelector(`.cookie-acceptance__modal[data-hide-on-vendor-consent="${cookie}"]`).style.display = 'block';
						}
						$.magnificPopup.close();
					}
				}
			},
			type: 'iframe'
		});

		$('.cookie-acceptance__modal button.close, .cookie-acceptance__modal button.accepter-cookies').on('click', e => {
			e.target.closest('.cookie-acceptance__modal').style.display = 'none';
		});

		$('#menutoggle').click(function(e){
		  	e.preventDefault();
		  	$('body>header').toggleClass('navactive');
		  	//$('body').toggleClass('fixed');
		});

    });


    $(window).on('load resize', function (event) {
    	if($(window).width() >= 768){
	    	var widthSearchForm = $(window).width() - $("#logo").innerWidth() - ($("#search").innerWidth() * 2) - 25;
	    	$("header #searchform").css("width",widthSearchForm);
	    	$("header #searchform").css("left",$("#logo").innerWidth() + 15);
    	}
    	if($(window).width() >= 1100){
	    	if( $("#valeurs .statement").length){
	    		var hauteur_statement_right = $("#valeurs .statement.right").innerHeight() + 1;
	    		$("#valeurs .statement.left").css("height",hauteur_statement_right);
	    	}
    	}

    	if( $("#banner").length && $("#banner.small").length==0 && $(window).width() >= 768){
    		var heightBanner = $(window).width() * 24.5 / 100;
    		$("#banner").css("height",heightBanner);
    	}
    	if( $("#slider").length && $(window).width() >= 768){
    		var heightSlider = $(window).width() * 32 / 100;
    		$("#slider").css("height",heightSlider);
    	}

    	if($(window).width() <= 768){
    		$("header #searchform").css("width",$(window).width() - 70);
	    	$("header #searchform").css("left","10px");

	    	if( $("#filtres").length){
	    		$(".choix_filtre .titre_filtre").on("click",function(e){
	    			var filtre_actif = $(this);

	    			if($(this).hasClass("active") === true){
	    				$(this).removeClass("active");

	    				$('html, body').animate({
					        scrollTop: $('#content > .wrapper').offset().top - $("body > header").height() - 10
					    }, 200);
	    				 e.stopImmediatePropagation();
	    			}else{
	    				$(".choix_filtre .titre_filtre").removeClass("active");
		    			filtre_actif.addClass("active");
		    			if($(this).next().find('.last').length){
		    				$(this).next().find('.last').remove();
		    			}
		    			$(this).next().append("<li class='last'>OK</li>");
		    			e.stopImmediatePropagation();
	    			}
	    		});
	    		$(".choix_filtre ul").on("click",".last",function(){
	    			$(this).parent().prev().removeClass("active");
	    			$('html, body').animate({
				        scrollTop: $('#content > .wrapper').offset().top - $("body > header").height() - 10
				    }, 200);
	    		});

	    		$(window).on('scroll', function (event) {
		        	var y=$(window).scrollTop();
		        	var filtresScrollTopPosition = $("#content > .wrapper").offset().top;
		 
	                if(y + 80 > filtresScrollTopPosition){
	                	$('#filtres').addClass("fixed");
	                }else{
	                	$('#filtres').removeClass("fixed");
	                }
		        });
	    	}
    	}
    });

    $(document).on( 'wpcf7mailsent', function( event ) {
	    $(".formulaire_contact").addClass("sent");
	     $('html, body').animate({
	        scrollTop: $('.formulaire_contact').offset().top - $("body > header").height()
	    }, 200);
	});


    var mySwiperActualites;
    var mySwiperVideos;
	$(window).on('load resize', function (event) {
		if($(window).width() <= 640){
			if (typeof mySwiperActualites == 'undefined') {
				mySwiperActualites = new Swiper ('#publications_home.swiper-containerr', {
				    direction: 'horizontal',
				    loop: false,
					spaceBetween: 0,
					slidesPerView: 1.3,
					pagination: {
					    el: '.swiper-pagination',
					    type: 'bullets',
					    clickable: true
					},
				});
			}
			if (typeof mySwiperVideos == 'undefined') {
				mySwiperVideos = new Swiper ('#videos_home.swiper-containerr', {
				    direction: 'horizontal',
				    loop: false,
					spaceBetween: 0,
					slidesPerView: 1.3, 
					pagination: {
					    el: '.swiper-pagination',
					    type: 'bullets',
					    clickable: true
					},
				});
			}
		}else{
			// clean up old instances and inline styles when available
 			if ( typeof mySwiperActualites !== 'undefined' ){
 				//console.log('here');
 				jQuery('#publications_home .swiper-wrapper').removeAttr('style');
        		jQuery('#publications_home .swiper-slide').removeAttr('style');
 				mySwiperActualites.destroy( true, true );
 				mySwiperActualites = undefined;
        		//console.log('removee');
        	}
        	if ( typeof mySwiperVideos !== 'undefined' ){
 				//console.log('here');
 				jQuery('#videos_home .swiper-wrapper').removeAttr('style');
        		jQuery('#videos_home .swiper-slide').removeAttr('style');
 				mySwiperVideos.destroy( true, true );
 				mySwiperVideos = undefined;
        		//console.log('removee');
        	}
		}
	});



})(jQuery);